
import "./Login.css";

export default function BannerMessage (props) {
  const variant = props.variant ?? "alert-danger create-fail"
  const displayMsg = props.msg ?? "Sorry, something unexpected went wrong"
  return (props.show ? 
    <div className={"alert alert-dismissible " + variant}>
      {displayMsg}
      <button type="button" className="bannerbtn" onClick={props?.close} data-dismiss="alert">
        &times;
      </button>
    </div> : null
  );    
}
